"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _polished = require("polished");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Number = _styledComponents.default.div`
  display: block;
  font: ${({
  theme
}) => theme.fonts.din};
  font-size: 24px;
  font-weight: bold;
  letter-spacing: ${(0, _polished.rem)(-2.0)};
  margin-top: ${({
  theme
}) => (0, _polished.rem)(-theme.spacing[0])};
  padding-bottom: ${({
  theme
}) => (0, _polished.rem)(theme.spacing[1])};
`;
const TopRow = _styledComponents.default.div`
  align-items: center;
  color: ${({
  theme
}) => theme.colors.white};
  display: flex;
  font-size: ${(0, _polished.rem)(10)};
  font-weight: 500;
  text-transform: uppercase;

  & > * {
    flex: 1;
  }
`;
const Content = ({
  children,
  title
}) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TopRow, null, title), /*#__PURE__*/_react.default.createElement(Number, null, children));
var _default = Content;
exports.default = _default;